<template>
  <div class="flex flex-row justify-content-between align-items-end">
    <div class="w25p pr-2">
      <label class="label-text pt-2">{{ $t("type") | capitalize }}</label>
      <Multiselect
        v-model="type"
        :options="types"
        :searchable="false"
        :allow-empty="true"
        :show-labels="false"
        track-by="tag"
        label="label"
        placeholder="Choose a type"
      />
    </div>

    <div class="w25p pr-2">
      <label class="label-text pt-2">{{ $t("language") | capitalize }}</label>
      <Multiselect
        v-model="extra.language"
        :options="languages"
        :searchable="true"
        :allow-empty="true"
        :show-labels="false"
        label="name"
        track-by="alpha_2"
        placeholder="Choose a language"
      />
    </div>
    <div class="w45p pr-4">
      <label class="label-text pt-2">{{ $t("value") | capitalize }}</label>
      <input
        v-model="extra.value"
        class="form-control custom-input"
        type="text"
      >
    </div>
    <div class="w5p py-2">
      <i
        v-if="showRemoveIcon"
        v-b-tooltip.hover
        style="color:#6f6f6f; font-size:16px;"
        class="fa fa-trash clickable"
        title="remove"
        @click="$emit('removeExtra')"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.w5p {
  width: 5% !important;
}

.w45p {
  width: 45% !important;
}

.custom-input {
  height: 40px;
  padding: 6px;
  color: black;
  border: 1px solid #888e99;
  border-radius: 4px;
}
</style>

<script>
import { ApiCalls } from "@/assets/libs/services"

export default {
  name: "RecordingExtra",
  props: {
    extra: Object,
    canRemove: Boolean,
  },
  data () {
    return {
      languages: [],
      types: [
        { label: "Alternate artist", tag: "artist" },
        { label: "Alternate title", tag: "title" },
      ]
    }
  },
  computed: {
    showRemoveIcon () {
      return this.canRemove || this.extra.tag || this.extra.language || this.extra.value
    },
    type: {
      get () {
        return this.types.filter(type => type.tag == this.extra.tag)
      },
      set (type) {
        this.extra.tag = type.tag
      }
    },
  },
  watch: {
    extra: {
      handler: function (newExtra) {
        if ((newExtra.tag != null) && (newExtra.language != null) && (Boolean(newExtra.value))) {
          this.extra.complete = true
        } else {
          this.extra.complete = false
        }
      },
      deep: true
    },
  },
  mounted: function () {
    ApiCalls.getLanguages()
      .then(response => {
        this.languages = response
      })
  }
}
</script>


